<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">
						{{ 'Business_Client_Policy_User.Deactivate' | translate }}?
					</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close"
							(click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<form name="vm.form" class="c-form u-ost-xl">
					<div class="o-grid o-grid--wrap">
					    <div class="o-grid__cell o-grid__cell--w-100 u-no-p u-osb-sm">
	                        {{ 'Employees.Name' | translate }}: {{vm.getName()}} ({{vm.policy.policyNumber}})
	                    </div>
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p" *ngIf="!vm.isInsuranceDatePickerHidden">
							<div class="c-form__group u-osb-lg">
								<label class="c-form__label c-form__label">
								    {{ 'Business_Client_Policy_User.Deactivation_Date' | translate }} *
								</label>
								<div id="datePickerContainer" *ngIf="vm.initialized">
								    <input-datepicker-new id="{{ 'terminate-' + vm.uid }}"
								                      name="terminationDate"
								                      [(model)]="vm.newTerminationDate"
								                      [startDate]="vm.newTerminationDate"
								                      [minDate]="vm.minDate"
								                      data-el-parent="datePickerContainer" 
								                      [hasTimepicker]="false"
								                      [hasCalendarIcon]="true"
								                      [isSingleDate]="true"
								                      [isFixedPosition]="true" 
								                      [isRequired]="true"></input-datepicker-new>
								</div>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button type="button"
	                            id="terminatePolicyUserButton"
								(click)="vm.submit()"
								[disabled]="vm.processing || !vm.initialized"
								class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Business_Client_Policy_User.Deactivate' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
